import React from 'react';
import { FieldTooltip } from './FieldTooltip';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  tooltip?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  tooltip,
  id,
  className = '',
  disabled,
  ...props
}) => {
  return (
    <div className={`flex items-center ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <input
        type="checkbox"
        id={id}
        className={`form-checkbox h-4 w-4 rounded border-heritage-grey accent-hero-red text-hero-red focus:ring-hero-red focus:ring-offset-0 ${
          disabled ? 'cursor-not-allowed bg-page-bg' : 'cursor-pointer'
        } ${className}`}
        disabled={disabled}
        {...props}
      />
      {label && (
        <label 
          htmlFor={id} 
          className={`ml-2 block text-[13px] select-none ${
            disabled ? 'text-heritage-grey cursor-not-allowed' : 'text-text-grey cursor-pointer'
          }`}
        >
          {label}
        </label>
      )}
      {label && tooltip && <FieldTooltip text={tooltip} />}
    </div>
  );
}; 